export const queryReferAFriend = groq`*[_type == "referAFriend" && currentPathname == $currentPathname][0]{
  ...,
}`;
